import { render, staticRenderFns } from "./schCont.vue?vue&type=template&id=4063e3f6&scoped=true&"
import script from "./schCont.vue?vue&type=script&lang=js&"
export * from "./schCont.vue?vue&type=script&lang=js&"
import style0 from "./schCont.vue?vue&type=style&index=0&id=4063e3f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4063e3f6",
  null
  
)

export default component.exports